import PlatformTestScenarios from './PlatformTestScenarios'

/* eslint-disable camelcase, no-await-in-loop */
export default class DCSTestScenarios extends PlatformTestScenarios {
  async bet_settleLose_settleWin_settleLose() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()

        await this.requests.settleLose({ data: { isEndRound: false } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ data: { isEndRound: false } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleLose({ data: { isEndRound: true } })
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }

  async multiBets_bet1_bet2_bet3_settle() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const BET_LENGTH = 3
        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          await this.requests.bet({ betIndexes: [betIndex] })
          betIndexes.push(betIndex)
        }

        await this.requests.settle({
          betIndexes,
          settleInfo: {
            winBetIndexes: [1],
          },
        })

        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }
}
